export const NOTIFICATIONS_DRAWER_PAGE_SIZE = 25;
export const EXPS = 'EXPS';
export const FILTER_BY_ACCOUNT_FORM_NAME =
  'Notification Preferences Drawer - By Account';
export const FILTER_BY_ACCOUNT_FORM_CONTENT = 'Account selected :';
export const FILTER_BY_ACCOUNT_FORM_LOCATION =
  'Filter by account – Notification Preferences';

export const SUBMIT_PREFERENCES_FORM_NAME = 'Notification Preferences Updated';
export const SUBMIT_PREFERENCES_FORM_LOCATION =
  'My Account - Notification Preferences';

export const ORDER_STATUS_LIST = {
  isReadyForPickupNotificationPreferred_Web: {
    label: 'SHIPPED_STATUS_RP',
    title: 'CAT_SHOPPING_PREFERENCES_PICKUP',
    statusIndex: 0
  },
  isReadyForPartiallyPickupNotificationPreferred_Web: {
    label: 'PARTIALLY_READY_PICKUP',
    title: 'CAT_SHOPPING_PREFERENCES_PICKUP',
    statusIndex: 1
  },
  isPickedUpNotificationPreferred_Web: {
    label: 'SHIPPED_STATUS_PU',
    title: 'CAT_SHOPPING_PREFERENCES_PICKUP',
    statusIndex: 2
  },
  isPartiallyShippedNotificationPreferred_Web: {
    label: 'MO_OrderStatus_V',
    title: 'DELIVERY',
    value: 'PS',
    statusIndex: 3
  },
  isFullyShippedNotificationPreferred_Web: {
    label: 'SHIPPED_STATUS_FS',
    title: 'DELIVERY',
    value: 'FS',
    statusIndex: 4
  },
  isDeliveredNotificationPreferred_Web: {
    label: 'SHIPPED_STATUS_DL',
    title: 'DELIVERY',
    value: 'DL',
    statusIndex: 5
  },
  isOrderExceptionNotificationPreferred_Web: {
    label: 'ORDER_PROBLEM',
    title: 'SHIPPED_STATUS_ON',
    value: 'EX',
    statusIndex: 11
  },
  isOrdProcOrdProcessingPreferred_Web: {
    label: 'SHIPPED_STATUS_OR',
    title: 'SHIPPED_STATUS_ON',
    value: 'EX',
    statusIndex: 12
  },
  SHIPPED_STATUS_ON: {
    label: 'SHIPPED_STATUS_ON',
    title: 'SHIPPED_STATUS_ON',
    value: 'OR',
    statusIndex: 13
  },
  isQuoteReminderExpiringTodayPreferred_Web: {
    title: 'NOTIFICATION_PREF_SUBHEADER',
    label: 'EXPIRING_TODAY',
    value: 'NEW',
    isToday: true,
    statusIndex: 22
  },
  isQuoteReminderExpiredPreferred_Web: {
    title: 'NOTIFICATION_PREF_SUBHEADER',
    label: 'EXPIRED_STATE',
    value: 'EXP',
    statusIndex: 23
  }
};

export const ORDER_STATUS_HEADING_SORTING_ORDER = {
  CAT_SHOPPING_PREFERENCES_PICKUP: 0,
  DELIVERY: 1,
  SHIPPED_STATUS_ON: 2,
  NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER: 3,
  NOTIFICATION_PREF_SUBHEADER: 4
};

export const ORDER_STATUS_DEFAULT_FILTERS = [
  {
    label: 'QUEUED_FOR_PROCESSING',
    name: 'isQueuedForProcessingPreferred_Web',
    value: true,
    title: 'SHIPPED_STATUS_ON',
    statusIndex: 6
  },
  {
    label: 'QUEUED_ORDER_NOT_PROCESSED_HEADING',
    name: 'isQueuedOrderNotProcessingPreferred_Web',
    value: true,
    title: 'SHIPPED_STATUS_ON',
    statusIndex: 7
  },
  {
    label: 'QUEUED_ORDER_PROCESSING_HEADING',
    name: 'isQueuedOrderProcessingPreferred_Web',
    value: true,
    title: 'SHIPPED_STATUS_ON',
    statusIndex: 8
  },
  {
    label: 'CANCELLED_STATE',
    name: 'isCancelledPreferred_Web',
    value: true,
    title: 'SHIPPED_STATUS_ON',
    statusIndex: 9
  },
  {
    label: 'SHIPPED_STATUS_OH',
    name: 'isHoldPreferred_Web',
    value: true,
    title: 'SHIPPED_STATUS_ON',
    statusIndex: 10
  }
];

export const ORDER_STATUS_CAL_SUBMITTER_DEFAULT_FILTERS = [
  {
    label: 'NOTIF_PREF_EXPIRED_APPROVAL_TITLE',
    name: 'isExpiredApprovalPreferred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER',
    statusIndex: 14
  },
  {
    label: 'SHIPPED_STATUS_OP',
    name: 'isOrderPlacedPreferred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER',
    statusIndex: 16
  },
  {
    label: 'ORG_ORDER_REJECTED',
    name: 'isOrderRejectedPreferred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER',
    statusIndex: 18
  },
  {
    label: 'CAT_ORD_STS_DELETED',
    name: 'isOrderDeletedPreferred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER',
    statusIndex: 19
  },
  {
    label: 'QUOTE_REJECTED',
    name: 'isQuoteRejectedPreferred_Web',
    title: 'NOTIFICATION_PREF_SUBHEADER',
    value: true,
    statusIndex: 21
  }
];

export const ORDER_STATUS_CAL_APPROVER_DEFAULT_FILTERS = [
  ...ORDER_STATUS_CAL_SUBMITTER_DEFAULT_FILTERS,
  {
    label: 'SUBMITTED_FOR_APPROVAL',
    name: 'isSubmittedForApprovalPrerred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER',
    statusIndex: 15
  },
  {
    label: 'ORDER_APPROVED',
    name: 'isOrderApprovedPreferred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_ORDER_APPROVAL_SUBHEADER',
    statusIndex: 17
  },
  {
    label: 'QUOTE_PENDING_APPROVAL',
    name: 'isQuotePendingApprovalPreferred_Web',
    value: true,
    title: 'NOTIFICATION_PREF_SUBHEADER',
    statusIndex: 20
  }
];
